import moment from 'moment';

UpdateCommentModalController.$inject = [
  '$scope',
  '$modalInstance',
  'timerecord',
];

export function UpdateCommentModalController(
  $scope,
  $modalInstance,
  timerecord
) {

  $scope.timerecord = timerecord;

  $scope.hasComment = !!$scope.timerecord.comment;

  $scope.date = moment(timerecord.date).format('dddd D MMMM YYYY')

  $scope.ok = function () {
    $modalInstance.close($scope.timerecord);
  };

  $scope.cancel = function () {
    $modalInstance.dismiss('cancel');
  };
}
